import React from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'

import { fetchObjective } from '../actions/objectives'
import { fetchPersistedSalesArqueos } from '../actions/arqueos'

import ErrorMessage from '../components/ErrorMessage'
import LoadingProgress from '../components/LoadingProgress'

import '../styles/ObjectivesAdminView.css'

class ObjectiveDetailsView extends React.Component {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const searchParams = new URLSearchParams(this.props.location.search);
    const year = searchParams.get('year');

    this.props.fetchObjective(this.props.match.params.customer, year)
      .then((answer) => {
        let arqueoObjective = answer.response
        const today = new Date(arqueoObjective.TimeStamp);
        const currentYear = today.getFullYear();
        const yearStart = new Date(currentYear, 0, 1);
        const formattedStartDate = `${yearStart.getFullYear()}-${(yearStart.getMonth() + 1).toString().padStart(2, '0')}-${yearStart.getDate().toString().padStart(2, '0')}`;
        const yearEnd = new Date(currentYear + 1, 0, 0);
        const formattedEndDate = `${yearEnd.getFullYear()}-${(yearEnd.getMonth() + 1).toString().padStart(2, '0')}-${yearEnd.getDate().toString().padStart(2, '0')}`;

        this.props.fetchPersistedSalesArqueos(formattedStartDate, formattedEndDate, '', arqueoObjective.Customer._id, '');
      })
      .catch((error) => {
        console.error(error);
      });
  }

  calculateTotalObjective(objective) {
    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const weeks = ['W1', 'W2', 'W3', 'W4', 'W5', 'W6'];

    let total = 0;
    months.forEach(month => {
      weeks.forEach(week => {
        total += objective[month][week]
      })
    })

    return total
  }

  calculateTotalMonthObjective(objective, month) {
    const weeks = ['W1', 'W2', 'W3', 'W4', 'W5', 'W6'];

    let total = 0;
    weeks.forEach(week => {
      total += objective[month][week]
    })

    return total
  }

  calculateTotalReal() {
    const salesArqueos = Array.isArray(this.props.salesArqueos) ? this.props.salesArqueos : [];

    let total = 0;
    salesArqueos.forEach(arqueo => {
      total += Number(arqueo.GMV_net || 0);
    });

    return total
  }

  calculateTotalMonthReal(month) {
    const salesArqueos = Array.isArray(this.props.salesArqueos) ? this.props.salesArqueos : [];
    const filtered = salesArqueos.filter(arqueo => new Date(arqueo.Day).getUTCMonth() === month);

    let total = 0;
    filtered.forEach(arqueo => {
      total += Number(arqueo.GMV_net || 0);
    });

    return total
  }

  getISOWeekNumber(date) {
    var firstDayOfMonth = new Date(date.getFullYear(), date.getMonth(), 1);
    var adjustment = (firstDayOfMonth.getDay() === 0 ? 6 : firstDayOfMonth.getDay() - 1);
    var daysSinceMonthStart = date.getDate() + adjustment;
    var weekNumber = Math.ceil(daysSinceMonthStart / 7);
    weekNumber = Math.max(weekNumber, 1);

    return weekNumber;
  }

  calculateTotalWeekReal(month, week) {
    const salesArqueos = Array.isArray(this.props.salesArqueos) ? this.props.salesArqueos : [];
    const filtered = salesArqueos.filter(arqueo => {
      const dayStr = (arqueo.Day || '').toString();
      const parts = dayStr.split(/[-T:.Z]/);
      const arqueoDate = new Date(Date.UTC(parts[0], parts[1] - 1, parts[2]));
      const arqueoWeekOfMonth = this.getISOWeekNumber(arqueoDate);
      const arqueoMonth = arqueoDate.getUTCMonth();

      return arqueoMonth === month && arqueoWeekOfMonth === week;
    });

    let total = 0;
    filtered.forEach(arqueo => {
      total += Number(arqueo.GMV_net || 0);
    });

    return total
  }

  progressBar(actual, objective) {
    const percentage = objective > 0 ? (actual / objective) * 100 : 0;
    const barWidth = Math.min(percentage, 100);

    let color = "warning"

    if (percentage < 50) {
      color = "danger"
    } else if (percentage >= 100) {
      color = "success"
    }

    return (
      <div className="obj-progress-container">
        <div className={`obj-progress-bar ${color}`} style={{ width: `${barWidth}%` }}></div>
        <div className="obj-progress-percentage">{percentage.toFixed(2)}%</div>
      </div>
    );
  }

  render() {
    const { objective, error, loading, role, salesArqueos } = this.props

    if (error) {
      return <ErrorMessage message={error.message} />
    }

    if (!objective || loading || !salesArqueos) {
      return <LoadingProgress />
    }

    const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
    const monthsES = ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'];
    const weeks = ['W1', 'W2', 'W3', 'W4', 'W5', 'W6'];

    const totalReal = this.calculateTotalReal()
    const totalObjective = this.calculateTotalObjective(objective)
    const percentage = totalObjective > 0 ? (totalReal / totalObjective) * 100 : 0
    const year = (new Date(objective.TimeStamp)).getFullYear()

    return (
      <div className="objectives-admin-view">
        {/* Header */}
        <div className="obj-admin-header">
          <div className="header-content">
            <div className="header-text">
              <h1>
                <i className="fas fa-bullseye mr-1"></i>
                {objective.Customer.Fullname} — {year}
              </h1>
            </div>
            <div className="header-actions">
              <Link to="/objectives" className="obj-admin-btn secondary">
                <i className="fas fa-arrow-left"></i>
                <span>Volver</span>
              </Link>
              {role === 'ADMIN' &&
                <Link to={`/objectives/${objective.Customer._id}/edit?year=${year}`} className="obj-admin-btn primary">
                  <i className="fas fa-edit"></i>
                  <span>Editar</span>
                </Link>
              }
            </div>
          </div>
        </div>

        {/* KPI Cards */}
        <div className="obj-kpi-row">
          <div className="obj-kpi-card real">
            <div className="kpi-icon"><i className="fas fa-coins"></i></div>
            <div className="kpi-content">
              <div className="kpi-value">{totalReal.toFixed(2)} €</div>
              <div className="kpi-label">Real {year}</div>
            </div>
          </div>
          <div className="obj-kpi-card objective">
            <div className="kpi-icon"><i className="fas fa-bullseye"></i></div>
            <div className="kpi-content">
              <div className="kpi-value">{totalObjective.toFixed(2)} €</div>
              <div className="kpi-label">Objetivo {year}</div>
            </div>
          </div>
          <div className="obj-kpi-card percentage">
            <div className="kpi-icon"><i className="fas fa-chart-line"></i></div>
            <div className="kpi-content">
              <div className="kpi-value">{percentage.toFixed(2)}%</div>
              <div className="kpi-label">Progreso</div>
            </div>
          </div>
        </div>

        {/* Annual Summary */}
        <div className="obj-total-card">
          <div className="obj-total-header">
            <i className="fas fa-calendar-alt"></i> Resumen Anual
          </div>
          <div className="obj-total-labels">
            <div className="obj-total-col col-customer">Cliente</div>
            <div className="obj-total-col col-year">Año</div>
            <div className="obj-total-col col-real">Real</div>
            <div className="obj-total-col col-objective">Objetivo</div>
            <div className="obj-total-col col-progress">Progreso</div>
            <div className="obj-total-col col-status">Estado</div>
          </div>
          <div className="obj-total-row">
            <div className="obj-total-col col-customer">{objective.Customer.Fullname}</div>
            <div className="obj-total-col col-year">{year}</div>
            <div className="obj-total-col col-real">{totalReal.toFixed(2)} €</div>
            <div className="obj-total-col col-objective">{totalObjective.toFixed(2)} €</div>
            <div className="obj-total-col col-progress">{this.progressBar(totalReal, totalObjective)}</div>
            <div className="obj-total-col col-status">
              {totalReal >= totalObjective ? (
                <span className="obj-status-badge achieved"><i className="fas fa-check-circle"></i> Alcanzado</span>
              ) : (
                <span className="obj-status-badge pending"><i className="fas fa-clock"></i> Pendiente</span>
              )}
            </div>
          </div>
        </div>

        {/* Month Cards */}
        <div className="obj-detail-month-grid">
          {months.map((month, index) => {
            const monthReal = this.calculateTotalMonthReal(index);
            const monthObjective = this.calculateTotalMonthObjective(objective, month);

            return (
              <div key={month} className="obj-detail-month-card">
                <div className="obj-detail-month-header">
                  <div className="obj-detail-month-title">
                    <i className="fas fa-calendar-day"></i> {monthsES[index]}
                  </div>
                  <div className="obj-detail-month-summary">
                    {monthReal.toFixed(2)} € / {monthObjective.toFixed(2)} €
                  </div>
                </div>
                <div className="obj-detail-month-total">
                  <div className="obj-detail-month-total-row">
                    <span className="obj-detail-month-total-label">Total mensual</span>
                    <span className="obj-detail-month-total-progress">{this.progressBar(monthReal, monthObjective)}</span>
                    <span className="obj-detail-month-total-status">
                      {monthReal >= monthObjective && monthObjective > 0 ? (
                        <span className="obj-status-badge achieved"><i className="fas fa-check-circle"></i></span>
                      ) : monthObjective > 0 ? (
                        <span className="obj-status-badge pending"><i className="fas fa-clock"></i></span>
                      ) : (
                        <span className="obj-status-badge neutral"><i className="fas fa-minus-circle"></i></span>
                      )}
                    </span>
                  </div>
                </div>
                <div className="obj-detail-week-table">
                  <div className="obj-detail-week-header">
                    <div className="obj-detail-week-col col-week">Semana</div>
                    <div className="obj-detail-week-col col-real">Real</div>
                    <div className="obj-detail-week-col col-objective">Objetivo</div>
                    <div className="obj-detail-week-col col-progress">Progreso</div>
                  </div>
                  {weeks.map((week, windex) => {
                    const weekReal = this.calculateTotalWeekReal(index, windex + 1);
                    const weekObjective = objective[month][week] || 0;

                    return (
                      <div key={`${month}.${week}`} className="obj-detail-week-row">
                        <div className="obj-detail-week-col col-week">{week}</div>
                        <div className="obj-detail-week-col col-real">{weekReal.toFixed(2)} €</div>
                        <div className="obj-detail-week-col col-objective">{weekObjective.toFixed(2)} €</div>
                        <div className="obj-detail-week-col col-progress">{this.progressBar(weekReal, weekObjective)}</div>
                      </div>
                    )
                  })}
                </div>
              </div>
            )
          })}
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => ({
  objective: state.objectives.objective,
  salesArqueos: state.arqueos.generatedSalesArqueos,
  error: state.objectives.error,
  loading: state.arqueos.loading,
  role: state.auth.role,
})

const mapDispatchToProps = dispatch => ({
  fetchObjective: bindActionCreators(fetchObjective, dispatch),
  fetchPersistedSalesArqueos: bindActionCreators(fetchPersistedSalesArqueos, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(ObjectiveDetailsView)

